<template>
	<v-select
		:items="items"
		:label="label"
		:placeholder="placeholder"
		:disabled="disabled"
		:dense="dense"
		:multiple="multiple"
		:value="selected"
		:clearable="clearable"
		:hint="hint"
		:persistent-hint="persistentHint"
		:error-count="3"
		:error-messages="errors || []"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		errors: {
			type: Array,
			default: () => [],
		},
		disabled: Boolean,
		dense: Boolean,
		label: String,
		placeholder: String,
		value: [String, Array, Boolean, Number],
		clearable: Boolean,
		hint: String,
		persistentHint: Boolean,
		multiple: Boolean,
	},
	computed: {
		selected() {
			return this.value
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
	},
}
</script>
